export default {
  products: {
    'you_are_searching': 'You are searching for',
    'no_results': 'No results.',
    'see_all': 'See all.',
    'see_product': 'See product',
    'retail_price': 'Retail price',
    'wholesale_price': 'Wholesale price',
    'see_wholesale_price': 'See wholesale price',
    'get_quote': 'Request for quotation',
    'from_your_waste': 'Products from your waste',
    'ready_products': 'Products',
    'filters_and_categories': 'Filters and categories',
  },
  sidebar: {
    categories: 'Category: ',
    filters: 'Filters',
    materials: 'Materials',
    designers: 'Designers',
    location: 'Location',
    price: 'Price',
    brand: 'Brand',
    material: 'Material',
    more: 'more...',
    less: 'less...',
    view: 'View',
    sortBy: 'Sort By',
    designer: 'Designer',
    name: 'Name',
    currency: 'EUR'
  },
};